"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Interactable_1 = require("./Interactable");
const SpaceContext_1 = require("./SpaceContext");
const utils_1 = require("./utils");
/**
 * If you have a part of your `Space` that you do not want to be pan-able for
 * some reason you can wrap it with `NoPanArea`. This has limited utility, but
 * might be useful in some cases.
 *
 * This doesn't affect zooming though.
 *
 * Must only be used inside a `Space`.
 *
 * ## Props
 *
 * See `NoPanAreaProps`.
 */
class NoPanArea extends React.PureComponent {
    constructor(props, context) {
        super(props);
        this.id = utils_1.generateRandomId();
        this.divRef = React.createRef();
        this.uniqueClassName = `react-zoomable-ui-no-pan-area-${this.id}`;
        this.determineClassName = () => {
            const { className } = this.props;
            if (className) {
                return `${className} ${this.uniqueClassName}`;
            }
            else {
                return this.uniqueClassName;
            }
        };
        this.constantStyles = `
div.${context.rootDivUniqueClassName} div.${this.uniqueClassName} {
  -ms-touch-action: default;
  -webkit-user-select: text;
  -webkit-touch-callout: default;
  user-select: text;
  cursor: auto;
} 
`;
    }
    componentDidMount() {
        this.context.registerInteractable(this);
    }
    componentWillUnmount() {
        this.context.unregisterInteractable(this);
    }
    render() {
        const { style } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("style", null, this.constantStyles),
            React.createElement("div", Object.assign({ id: this.props.id }, { [Interactable_1.InteractableIdAttributeName]: this.id }, { className: this.determineClassName(), style: style, ref: this.divRef }), this.props.children)));
    }
}
exports.NoPanArea = NoPanArea;
NoPanArea.contextType = SpaceContext_1.SpaceContext;
//# sourceMappingURL=NoPanArea.js.map